import React, { Suspense, useEffect } from "react";
import { Redirect, Switch } from "react-router-dom";
import { CCol, CContainer, CFade, CRow } from "@coreui/react";

// routes config
import routes from "../routes";
import ReactPlaceholder from "react-placeholder/lib";
import { RectShape, TextRow } from "react-placeholder/lib/placeholders";
import { PrivateRoute } from "../components/PrivateRoute";
import { useState } from "react";
import { useSelector } from "react-redux";

const customPlaceHolder = (
  <>
    <CRow className="mt-5">
      <CCol md={8}>
        <RectShape
          color="#c3d3e8"
          style={{ width: "100%", height: 20, borderRadius: "4px" }}
        />
      </CCol>
      <CCol md={2} className="offset-md-2">
        <RectShape
          color="#c3d3e8"
          style={{ width: "100%", height: 20, borderRadius: "4px" }}
        />
      </CCol>
    </CRow>
    <CRow className="mt-5">
      <CCol md={6}>
        <RectShape
          color="#e2e8f0"
          style={{ width: "100%", height: 20, borderRadius: "4px" }}
        />
      </CCol>
      <CCol md={3}>
        <RectShape
          color="#e2e8f0"
          style={{ width: "100%", height: 20, borderRadius: "4px" }}
        />
      </CCol>
      <CCol md={3}>
        <RectShape
          color="#e2e8f0"
          style={{ width: "100%", height: 20, borderRadius: "4px" }}
        />
      </CCol>
    </CRow>
    <CRow className="mt-2">
      <CCol>
        <TextRow color="#e2e8f0" />
        <TextRow color="#c3d3e8" />
        <TextRow color="#c3d3e8" />
        <TextRow color="#e2e8f0" />
        <TextRow color="#c3d3e8" />
      </CCol>
    </CRow>
  </>
);

const loading = (
  <ReactPlaceholder
    type="text"
    ready={false}
    customPlaceholder={customPlaceHolder}
  />
);

const TheContent = () => {
  const [allowedRoutes, setAllowedRoutes] = useState([...routes]);
  const user = useSelector(state => state.auth.user);

  useEffect(() => {
    function loadRoles() {
      if (user.profile.Permission.length) {
        let allowedRoutes = [];
        for (var i = 0; i < routes.length; i++) {
          const route = routes[i];
          if (route.permission) {
            if (user.profile.Permission.indexOf(route.permission) > -1)
              allowedRoutes.push(route);
          }
          else {
            allowedRoutes.push(route);
          }
        }

        setAllowedRoutes(allowedRoutes);
      }
    }

    if (user) {
      loadRoles();
    }
  }, [user])

  return (
    <main className="c-main position-relative">
      <CContainer fluid>
        <Suspense fallback={loading}>
          <Switch>
            {allowedRoutes.map((route, idx) => {
              return (
                route.component && (
                  <PrivateRoute
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => (
                      <CFade>
                        <route.component {...props} key={Date.now()} />
                      </CFade>
                    )}
                  />
                )
              );
            })}
            <Redirect from="/" to="/dashboard" />
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  );
};

export default React.memo(TheContent);
